module.exports = __webpack_public_path__ + "img/dark-insights.df220157.png";